/* Tarjeta (23 oct 2026, fallo de Moon: «opción de ver la foto sin atrio, solamente frente; al hacer hover, clic para
   más zoom o de lado para ver la parte de atrás»).
   Tres cosas, todas sobre snippets/tarjeta.liquid:
   1. Vista «Con fondo · Solo frente» (snippets/vista-selector en la barra del catálogo): html[data-vista="frente"]
      esconde el compuesto de WOP y muestra el escaneo frontal a secas (CSS en assets/tarjeta.css). Se guarda en
      localStorage («moons:vista») y layout/theme.liquid la lee antes de pintar, como el tema.
   2. Voltear: el botón «Ver el reverso» crea el <img> del dorso la primera vez (no se descarga hasta que alguien lo pide)
      y alterna frente y reverso en la misma tarjeta.
   3. Zoom: el botón de la lupa abre el súper zoom (assets/zoom.js) con frente y reverso en máxima resolución. En las
      páginas sin ficha el diálogo no existe: se pide por Section Rendering (sections/zoom-dialogo) junto con su CSS
      y su JS la primera vez, y de ahí en adelante ya está.
   Los botones nacen con hidden y aquí se muestran: sin JS no hay botones muertos. */
(function () {
  if (window.MoonsTarjeta) return;
  var html = document.documentElement;
  var CLAVE = 'moons:vista';

  /* ---------- 1. Vista ---------- */
  function vistaActual() { return html.getAttribute('data-vista') === 'frente' ? 'frente' : 'fondo'; }

  function aplicaVista(v) {
    if (v === 'frente') html.setAttribute('data-vista', 'frente');
    else html.removeAttribute('data-vista');
    try { localStorage.setItem(CLAVE, v); } catch (e) { /* navegación privada */ }
    pintaSelector();
  }

  function pintaSelector() {
    var v = vistaActual();
    Array.prototype.forEach.call(document.querySelectorAll('[data-vista-opcion]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-vista-opcion') === v ? 'true' : 'false');
    });
  }

  /* ---------- 2. Voltear ---------- */
  function caja(boton) { return boton.closest('.tarjeta') ? boton.closest('.tarjeta').querySelector('.tarjeta__imagen') : null; }

  function voltea(boton) {
    var imagen = caja(boton);
    if (!imagen) return;
    var reverso = imagen.querySelector('.tarjeta__escaneo--reverso');
    if (!reverso) {
      reverso = document.createElement('img');
      reverso.className = 'tarjeta__escaneo tarjeta__escaneo--reverso';
      reverso.src = imagen.getAttribute('data-reverso-src');
      var srcset = imagen.getAttribute('data-reverso-srcset');
      if (srcset) reverso.srcset = srcset;
      var sizes = imagen.getAttribute('data-sizes');
      if (sizes) reverso.sizes = sizes;
      reverso.alt = imagen.getAttribute('data-reverso-alt') || '';
      reverso.decoding = 'async';
      imagen.appendChild(reverso);
    }
    var alReverso = !imagen.classList.contains('is-reverso');
    imagen.classList.toggle('is-reverso', alReverso);
    boton.setAttribute('aria-pressed', alReverso ? 'true' : 'false');
    var texto = boton.querySelector('[data-voltear-texto]');
    if (texto) texto.textContent = boton.getAttribute(alReverso ? 'data-t-frente' : 'data-t-reverso');
    boton.setAttribute('title', boton.getAttribute(alReverso ? 'data-t-frente' : 'data-t-reverso'));
  }

  /* ---------- 3. Zoom ---------- */
  var cargandoZoom = null;

  function cargaZoom() {
    if (window.MoonsZoom) return Promise.resolve();
    if (cargandoZoom) return cargandoZoom;
    var ruta = html.getAttribute('data-zoom-seccion') || 'zoom-dialogo';
    cargandoZoom = fetch('/?section_id=' + encodeURIComponent(ruta), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (htmlSeccion) {
        if (!document.querySelector('[data-lightbox]')) {
          var cont = document.createElement('div');
          cont.innerHTML = htmlSeccion;
          var dlg = cont.querySelector('[data-lightbox]');
          var css = cont.querySelector('link[rel="stylesheet"]');
          if (css) document.head.appendChild(css);
          if (dlg) document.body.appendChild(dlg);
        }
        var src = html.getAttribute('data-zoom-js');
        if (!src) throw new Error('sin zoom.js');
        return new Promise(function (ok, mal) {
          var s = document.createElement('script');
          s.src = src;
          s.onload = function () { ok(); };
          s.onerror = function () { mal(new Error('zoom.js')); };
          document.head.appendChild(s);
        });
      })
      .then(function () { if (!window.MoonsZoom) throw new Error('MoonsZoom'); })
      .catch(function (e) { cargandoZoom = null; throw e; });
    return cargandoZoom;
  }

  function dato(el, n) { return el.getAttribute('data-' + n) || ''; }

  function listaZoom(imagen) {
    var lista = [];
    var frenteSrc = dato(imagen, 'frente-src');
    var reversoSrc = dato(imagen, 'reverso-src');
    var alt = dato(imagen, 'alt');
    if (frenteSrc) {
      lista.push({ src: frenteSrc, grande: dato(imagen, 'frente-grande') || frenteSrc, ancho: parseInt(dato(imagen, 'frente-ancho'), 10) || 0, alto: parseInt(dato(imagen, 'frente-alto'), 10) || 0, etiqueta: dato(imagen, 't-frente'), alt: alt });
    } else {
      var atrio = imagen.querySelector('.tarjeta__escaneo--atrio');
      if (atrio) lista.push({ src: atrio.currentSrc || atrio.src, grande: dato(imagen, 'atrio-grande') || atrio.src, ancho: parseInt(dato(imagen, 'atrio-ancho'), 10) || 0, alto: parseInt(dato(imagen, 'atrio-alto'), 10) || 0, etiqueta: dato(imagen, 't-carta'), alt: alt });
    }
    if (reversoSrc) {
      lista.push({ src: reversoSrc, grande: dato(imagen, 'reverso-grande') || reversoSrc, ancho: parseInt(dato(imagen, 'reverso-ancho'), 10) || 0, alto: parseInt(dato(imagen, 'reverso-alto'), 10) || 0, etiqueta: dato(imagen, 't-reverso'), alt: dato(imagen, 'reverso-alt') || alt });
    }
    return lista;
  }

  function amplia(boton) {
    var imagen = caja(boton);
    if (!imagen) return;
    var lista = listaZoom(imagen);
    if (!lista.length) return;
    var indice = imagen.classList.contains('is-reverso') && lista.length > 1 ? 1 : 0;
    boton.classList.add('is-cargando');
    cargaZoom().then(function () {
      boton.classList.remove('is-cargando');
      window.MoonsZoom.abre(lista, indice, null);
    }).catch(function () {
      boton.classList.remove('is-cargando');
      /* Sin zoom (red caída o sección ausente): la ficha sigue siendo el camino */
      var enlace = boton.closest('.tarjeta') && boton.closest('.tarjeta').querySelector('.tarjeta__enlace');
      if (enlace) window.location.href = enlace.href;
    });
  }

  /* ---------- Botones: mostrar los que nacen hidden (también los que lleguen después: cargar más, Para ti…) ---------- */
  function muestraBotones(raiz) {
    Array.prototype.forEach.call((raiz || document).querySelectorAll('[data-tarjeta-acciones][hidden]'), function (a) {
      /* Sin reverso no hay botón de voltear; sin ninguna imagen, nada */
      var imagen = a.closest('.tarjeta') && a.closest('.tarjeta').querySelector('.tarjeta__imagen');
      if (!imagen) return;
      var voltear = a.querySelector('[data-voltear]');
      if (voltear && !imagen.getAttribute('data-reverso-src')) voltear.remove();
      a.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var opcion = e.target.closest('[data-vista-opcion]');
    if (opcion) { aplicaVista(opcion.getAttribute('data-vista-opcion')); return; }
    var voltear = e.target.closest('[data-voltear]');
    if (voltear) { e.preventDefault(); voltea(voltear); return; }
    var lupa = e.target.closest('[data-ampliar-tarjeta]');
    if (lupa) { e.preventDefault(); amplia(lupa); }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === CLAVE && e.newValue && e.newValue !== vistaActual()) aplicaVista(e.newValue);
  });

  muestraBotones(document);
  Array.prototype.forEach.call(document.querySelectorAll('[data-vista-selector]'), function (s) { s.hidden = false; });
  pintaSelector();
  if (window.MutationObserver) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        if (cambios[i].addedNodes.length) { muestraBotones(document); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.MoonsTarjeta = { vista: vistaActual, aplicaVista: aplicaVista };
})();
